import React from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter,InputGroup, Input,InputGroupAddon, Label } from 'reactstrap';
import FacebookLogin from 'react-facebook-login';

import GlobalStorage from '../storage/GlobalStorage'
import AppConnector from '../../AppConnector'
import axios from 'axios'


export default class extends React.Component{

  constructor(props)
  {
    super(props);
    this.state = {
      
    }    
  }

  login()
  {
    let GS = new GlobalStorage();
    let connector = new AppConnector();
    let formData; 
    let api_url;
    if (document.getElementById("username").value=="kwongsham@gmail.com"){
     formData = new FormData();
      formData.append('email', document.getElementById("username").value);
      formData.append('password', document.getElementById("password").value);
      api_url = global.CMS_URL+'admin/users/login';
    }
    else{ 
      formData = {};
      formData.phoneNumber=document.getElementById("username").value;   
      formData.password=document.getElementById("password").value;
      formData.deviceType="GCM";

      var dateObj = new Date();
      var month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
      var date = ('0' + dateObj.getDate()).slice(-2);
      var year = dateObj.getFullYear();
      var shortDate = year + '/' + month + '/' + date;
      formData.deviceId=shortDate;
      formData.countryCode="+852";
      
      api_url = global.API_URL+'readers/login';
    }
    axios({
      method: 'post',
      //url: global.API_URL+'readers/login',
      url: api_url,
      data:formData,
      headers: {
        'Content-Type': 'application/json',
      }
    })
    .then(response => {
      if (global.DEBUG){
        console.log('Login Success Response:', response.data)
      }
      GS.setUser(response.data);            
      
      connector.listStory(()=>{
        
        if (GS.getUserStory().length==0){
          this.props.switchMain('StoryList')
          this.props.switchMenu('StoryList')
          this.props.toggleModalState('createStory');
        }else{
          this.props.switchMain('StoryList');
          this.props.switchMenu('StoryList');
          this.props.toggleModal();
        }
      },1);      
    })
    .catch(error => {
      console.log(error)
      if (error.response.data.exception === 'com.gt.tbc.api.exceptions.ResourceNotFoundException' || 
        error.response.data.exception === 'com.gt.tbc.api.exceptions.IncorrectPasswordException'
        ) 
      {
        //console.log('Incorrect email and/or password.');
        alert("錯誤的會員資料，請重新輸入！")
      } else {
        console.log('An error occurred. Please try again.');        
      }    
    });
  }

  facebook_login(accessToken)
  {
    let GS = new GlobalStorage();
    let connector = new AppConnector();
    
    let formData = {};
    formData.facebookToken=accessToken;
    

    axios({
      method: 'post',
      url: global.API_URL+'readers/facebook',
      data:formData,
      headers: {
        'Content-Type': 'application/json',
      }
    })
    .then(response => {
      if (global.DEBUG){
        console.log('Login Success Response:', response.data)
      }
      GS.setUser(response.data);            
      
      connector.listStory(()=>{        
        if (GS.getUserStory().length==0){
          this.props.switchMain('StoryList')
          this.props.switchMenu('StoryList')
          this.props.toggleModalState('createStory');
        }else{
          this.props.switchMain('StoryList');
          this.props.switchMenu('StoryList');
          this.props.toggleModal();
        }
      },1);      
    })
    .catch(error => {
      console.log(error)
      if (error.response.data.exception === 'com.gt.tbc.api.exceptions.ResourceNotFoundException' || 
        error.response.data.exception === 'com.gt.tbc.api.exceptions.IncorrectPasswordException'
        ) 
      {
        //console.log('Incorrect email and/or password.');
        alert("錯誤的會員資料，請重新輸入！")
      } else {
        console.log('An error occurred. Please try again.');        
      }    
    });
  }

  _handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.login()
    }
  }


  render()
  {
    return (
      <div>
        <ModalHeader toggle={()=>{this.props.toggleModal()}}>請先登入tbc 會員*：</ModalHeader>
        <ModalBody>
          <InputGroup>
            <InputGroupAddon addonType="prepend">@</InputGroupAddon>
            <Input 
              id="username" 
              placeholder="電話號碼" 
              //value="kwongsham@gmail.com"
            />
          </InputGroup>                
          <InputGroup>                  
              <Input
                id="password" 
                type="password"                    
                placeholder="密碼"   
                onKeyDown={this._handleKeyDown}                                     
                //value="Tbc61369937"
              />
          </InputGroup>
          <p class="mt-3 mb-0">*請先下載TBC app進行註冊</p>
      
          <FacebookLogin
            appId={global.facebook_app_id}
            autoLoad={true}
            scope="public_profile,email"            
            callback={(response)=>{
              console.log(response.accessToken);
              this.facebook_login(response.accessToken);
            }} 
            version="5.0"
            xfbml={true}
            cookie={true}
            size="btn-primary"
            cssClass="btn"
            autoLoad="true"
            fields="id,name"
          />
          
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={()=>{this.login()}}>登入</Button>{' '}              
        </ModalFooter>
      </div>
    )
  }
}